import React from 'react';
import TextareaInput from '../Global/Forms/TextareaInput';
import AccordionGroup from '../Global/Forms/AccordionGroup';
import UnorderedList from '../Global/Forms/UnorderedList';
import OrderedList from '../Global/Forms/OrderedList';
import StreamInput from '../Global/Forms/StreamInput';
import DeleteButton from '../Global/Buttons/DeleteButton';
import ImageUploadOrDiagramSelect from '../Global/Forms/ImageUploadOrDiagramSelect';

const ManageContentSelectInputType = ({ content, contentIndex, deleteInput, addTextarea, addListItem, addAccordionRow, onChange, onDiagramChange }) => {
  let inputType;
  const freeformClass = `freeform-input freeform-${content.type}`;

  const onChangeWrap = patch => (e) => {
    onChange(e, contentIndex, patch);
  };

  const onDiagramChangeWrap = (diagram) => {
    onDiagramChange(diagram, contentIndex);
  };

  const handleKeyPress = (e) => {
    const code = (e.keyCode ? e.keyCode : e.which);
    if (code === 13) { // Enter
      e.preventDefault();
      addTextarea(contentIndex);
    }
  };

  switch (content.type) {
    case 'heading':
      if (content.static === true) {
        inputType = (
          <div className="heading-with-tooltip">
            <h2 className="heading">{content.data}</h2>
          </div>
        );
      } else {
        inputType = (
          <div className={freeformClass}>
            <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
            <TextareaInput
              name={`main_content[${contentIndex}].data`}
              value={content.data}
              placeholder="Click to add heading"
              onChange={onChangeWrap({ type: content.type })}
              autoResize
            />
          </div>
        );
      }
      break;

    case 'text':
      inputType = (
        <div className={freeformClass}>
          <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
          <TextareaInput
            name={`main_content[${contentIndex}].data`}
            value={content.data}
            placeholder="Click to add text"
            onChange={onChangeWrap({ type: content.type })}
            onKeyPress={handleKeyPress}
            autoResize
          />
        </div>
      );
      break;

    case 'bullet_list':
      inputType = (
        <div className={freeformClass}>
          <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
          <UnorderedList deleteInput={deleteInput} listItems={content.data} contentIndex={contentIndex} addListItem={addListItem} onChangeWrap={onChangeWrap} />
        </div>
      );
      break;

    case 'number_list':
      inputType = (
        <div className={freeformClass}>
          <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
          <OrderedList deleteInput={deleteInput} listItems={content.data} contentIndex={contentIndex} addListItem={addListItem} onChangeWrap={onChangeWrap} />
        </div>
      );
      break;

    case 'accordion':
      inputType = (
        <div className={freeformClass}>
          <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
          <AccordionGroup deleteInput={deleteInput} accordions={content.data} contentIndex={contentIndex} addRow={addAccordionRow} onChangeWrap={onChangeWrap} />
        </div>
      );
      break;

    case 'image':
      inputType = (
        <div className={freeformClass}>
          <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
          <ImageUploadOrDiagramSelect
            name={`main_content[${contentIndex}].data`}
            image={content.data}
            onImageChange={onChangeWrap({ type: content.type })}
            onDiagramChange={diagram => onDiagramChangeWrap(diagram)}
          />
        </div>
      );
      break;

    case 'bespoke_stream':
      inputType = (
        <div className={freeformClass}>
          <DeleteButton onClick={(e) => { e.preventDefault(); deleteInput(contentIndex); }} />
          <StreamInput name={`main_content[${contentIndex}].data`} value={content.data.iframe} onChange={onChangeWrap({ type: content.type })} />
        </div>
      );
      break;
    // no default
  }

  return inputType;
};

// No Proptypes in this file, any reason?
export default ManageContentSelectInputType;



// WEBPACK FOOTER //
// ./library/app/components/Create/ManageContentSelectInputType.js